"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCardGroup = void 0;
const react_1 = __importStar(require("react"));
const radio_card_1 = require("./radio-card");
const radio_card_group_styles_1 = require("./radio-card-group.styles");
require("./radio-card-group.types");
const RadioCardGroup = ({ value, name, items, error, currency, onChange, desktopWidth, desktopGap, textAlign, horizontalAlign, defaultValue, isBasicVersion, className, testId = 'radiocards', }) => {
    const [selectedValue, setSelectedValue] = (0, react_1.useState)(value);
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        onChange && onChange(event);
    };
    const getCheckedValue = (value, selectedValue) => {
        if (typeof value === 'boolean') {
            return String(value) === selectedValue;
        }
        else {
            return value === selectedValue;
        }
    };
    const isCurrency = currency ? true : false;
    return (react_1.default.createElement(radio_card_group_styles_1.StyledRadioCardGroup, { horizontalAlign: horizontalAlign, isCurrency: isCurrency, isBasicVersion: isBasicVersion, desktopGap: desktopGap, className: className }, items.map((item) => (react_1.default.createElement(radio_card_group_styles_1.StyledRadioCardWrapper, { desktopWidth: desktopWidth, key: item.id, isCurrency: isCurrency, isBasicVersion: isBasicVersion },
        react_1.default.createElement(radio_card_1.RadioCard, Object.assign({}, item, { name: name, checked: getCheckedValue(item.value, defaultValue ? defaultValue : selectedValue), error: error, onChange: handleChange, textAlign: textAlign, currency: currency, isBasicVersion: isBasicVersion, testId: `${testId}-${item.value}` })))))));
};
exports.RadioCardGroup = RadioCardGroup;
